module.exports = __webpack_public_path__ + "img/money_payment.9bcaa97a.gif";